import { render, staticRenderFns } from "./SideCenterPublishTemplate.vue?vue&type=template&id=79064cd6&scoped=true&"
import script from "./SideCenterPublishTemplate.vue?vue&type=script&lang=js&"
export * from "./SideCenterPublishTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SideCenterPublishTemplate.vue?vue&type=style&index=0&id=79064cd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79064cd6",
  null
  
)

export default component.exports